"use strict";

import angular from "angular";

import tippy from "tippy.js";
import template from "./tippy-popover.component.html";
import "./tippy-popover.component.scss";

class TippyPopoverComponent {
    context = {};
    hiddeButtons = [];
    listeners = [];
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;
    }

    $onInit() {
        setTimeout(() => {
            this.create();
        }, 500);
    }

    create() {
        const button = this.$element[0].getElementsByClassName(
            "tippy-popover__button"
        );
        const content = this.$element[0].getElementsByClassName(
            "tippy-popover__content"
        );
        content[0].style.display = "block";
        const backdrop = this.$element[0].querySelector("#TippyBackdrop");
        this.context = tippy(button[0], {
            content: content[0],
            trigger: "click",
            animation: "scale",
            arrow: true,
            placement: this.placement || "bottom-start",
            interactive: true,
            allowHTML: true,
            theme: "popover",
            hideOnClick: false,
            appendTo: this.appendTo || (() => document.body), // Força o popover a ser anexado ao body
            offset: this.coverButton ? [0, -button[0].offsetHeight] : [0, 10],
            popperOptions: {
                strategy: "fixed",
                modifiers: [
                    {
                        name: "flip",
                        enabled: !this.fixedPlacement,
                        options: {
                            fallbackPlacements: ["bottom", "right"]
                        }
                    },
                    {
                        name: "preventOverflow",
                        options: {
                            altAxis: true,
                            tether: false,
                            mainAxis: !this.fixedPlacement
                        }
                    }
                ]
            },
            onShow: (instance) => {
                backdrop.style.display = "block";
            },
            onMount: (instance) => {
                this.listeners = [];
                this.hiddeButtons = instance.popper.querySelectorAll(
                    "[popover-hide]"
                );
                for (const button of this.hiddeButtons) {
                    const attr = button.getAttribute("popover-hide");
                    const clickHandler = () => {
                        if (this.afterHidePop) {
                            this.afterHidePop({ response: attr });
                        }
                        instance.hide();
                    };
                    button.addEventListener("click", clickHandler, {
                        once: true
                    });
                    this.listeners.push({
                        event: "click",
                        handler: clickHandler
                    });
                }
            },
            onHide: (instance) => {
                backdrop.style.display = "none";
                this.listeners.forEach(({ event, handler }, index) => {
                    this.hiddeButtons[index].removeEventListener(
                        event,
                        handler
                    );
                });
            }
        });

        if (this.nameInstance) {
            this.$scope.$emit(
                `popOverInstance${this.nameInstance}`,
                this.context
            );
        }
        backdrop.addEventListener("click", () => {
            if (this.afterHidePop) {
                this.afterHidePop({ response: false });
            }
            this.context.hide(); // Hide the popover
        });
    }
}

TippyPopoverComponent.$inject = ["$element", "$scope"];

const component = {
    bindings: {
        afterHidePop: "&",
        placement: "@",
        nameInstance: "<",
        appendTo: "<",
        fixedPlacement: "<",
        coverButton: "<"
    },
    transclude: {
        popoverButton: "popoverButton",
        popoverContent: "popoverContent"
    },
    controller: TippyPopoverComponent
};

const name = "tippyPopoverComponent";
const def = {
    ...component,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
